export default `vec4 p = vec4(p0,3.);
    escape = 0.;
    p*= 2./min(dot(p.xyz,p.xyz),30.);
    for(int i = 0; i < 16; i++){
      p.xyz = vec3(2.,4.1,1.)-(abs(p.xyz)-vec3(1.,4.1,3.));
      p.xyz = mod(p.xyz-4., 8.)-4.;
      p *= 9./min(dot(p.xyz,p.xyz),12.);
      escape += exp(-0.2*dot(p.xyz,p.xyz));
    }
    p.xyz -= clamp(p.xyz, -1.2,1.2);
    return length(p.xyz)/p.w;
  }`